import { render, staticRenderFns } from "./CompanyInviteSuppliers.vue?vue&type=template&id=5f5d0579&"
import script from "./CompanyInviteSuppliers.vue?vue&type=script&lang=js&"
export * from "./CompanyInviteSuppliers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports